import { j as o } from "../../../_virtual/jsx-runtime.js";
import { cn as i } from "../../../lib/utils.js";
import y from "../../atoms/Button/index.js";
import { DropdownMenu as O, DropdownMenuTrigger as P, DropdownMenuPortal as R, DropdownMenuContent as I } from "../../ui/dropdown-menu.js";
import { useState as a } from "react";
const q = ({
  tabs: l,
  variant: r = "rounded",
  orientation: c = "row",
  gap: h = 8,
  size: m = "md",
  activeTab: d,
  onTabChange: s,
  className: k,
  rightContent: j,
  dropdownPosition: C = "right",
  dropdownPositionOffset: N = 18,
  isLoading: p
}) => {
  const D = l.some((e) => e.component), [f, t] = a(
    {}
  ), u = (e) => {
    e.disabled || (s && s(e.key), !e.component && e.onClick && e.onClick());
  }, w = (e) => {
    t((n) => ({ ...n, [e]: !1 })), d === e && (s == null || s(null));
  }, g = (e, n) => {
    t((M) => ({ ...M, [n.key]: e })), e && !f[n.key] && u(n), e || w(n.key);
  }, x = i(
    "justify-start font-medium",
    r === "full" && "w-full"
  );
  return /* @__PURE__ */ o.jsxs("div", { className: k, children: [
    /* @__PURE__ */ o.jsxs(
      "div",
      {
        className: i(
          "flex items-center justify-between flex-wrap md:flex-nowrap gap-3",
          c === "row" && "px-6 py-4 border-l-2 border-grey-200"
        ),
        children: [
          /* @__PURE__ */ o.jsx(
            "div",
            {
              className: i(
                "flex",
                c === "row" ? "flex-row" : "flex-col w-full"
              ),
              style: { gap: h },
              children: l.map(
                (e) => e.hasDropdown ? /* @__PURE__ */ o.jsxs(
                  O,
                  {
                    modal: !0,
                    open: f[e.key],
                    onOpenChange: (n) => g(n, e),
                    children: [
                      /* @__PURE__ */ o.jsx(P, { asChild: !0, children: /* @__PURE__ */ o.jsx(
                        y,
                        {
                          isLoading: p,
                          leftIconProps: {
                            iconName: e.iconName
                          },
                          isRounded: r === "rounded",
                          size: m,
                          bgColor: d === e.key ? "light" : "white",
                          className: x,
                          disabled: e.disabled,
                          children: e.labelContent
                        }
                      ) }),
                      /* @__PURE__ */ o.jsx(R, { children: /* @__PURE__ */ o.jsx("div", { className: "fixed inset-0 bg-black/10 z-50" }) }),
                      /* @__PURE__ */ o.jsx(
                        I,
                        {
                          sticky: "always",
                          side: C,
                          sideOffset: N,
                          className: "p-0 overflow-y-hidden",
                          children: typeof e.dropdownContent == "function" ? e.dropdownContent(() => w(e.key)) : e.dropdownContent
                        }
                      )
                    ]
                  },
                  e.key
                ) : /* @__PURE__ */ o.jsx(
                  y,
                  {
                    isLoading: p,
                    leftIconProps: {
                      iconName: e.iconName
                    },
                    isRounded: r === "rounded",
                    size: m,
                    bgColor: d === e.key ? "light" : "white",
                    onClick: () => u(e),
                    className: x,
                    disabled: e.disabled,
                    children: e.labelContent
                  },
                  e.key
                )
              )
            }
          ),
          j
        ]
      }
    ),
    D && /* @__PURE__ */ o.jsx(o.Fragment, { children: l.map(
      (e) => d === e.key && e.component && /* @__PURE__ */ o.jsx("div", { children: e.component }, e.key)
    ) })
  ] });
};
export {
  q as default
};
